import {
  getVisibleHighConfidenceItems,
  moveLowConfidenceItemsToHidden,
} from '@ltvco/refresh-lib/utils';

import type { Owner } from '@ltvco/refresh-lib/v1';

interface IGetHighConfidenceDisplayDataParams {
  owner: Owner;
  showHighConfidenceDataOnly: boolean;
  highConfidenceThreshold: number;
}

export const getHighConfidenceDisplayData = ({
  owner,
  showHighConfidenceDataOnly,
  highConfidenceThreshold,
}: IGetHighConfidenceDisplayDataParams) => {
  const phonesForDisplay = moveLowConfidenceItemsToHidden(
    owner.phones,
    showHighConfidenceDataOnly,
    highConfidenceThreshold
  );
  const emailsForDisplay = moveLowConfidenceItemsToHidden(
    owner.emails,
    showHighConfidenceDataOnly,
    highConfidenceThreshold
  );
  const addressesForDisplay = moveLowConfidenceItemsToHidden(
    owner.addresses,
    showHighConfidenceDataOnly,
    highConfidenceThreshold
  );

  const imagesForOverview = showHighConfidenceDataOnly
    ? getVisibleHighConfidenceItems(owner.images, highConfidenceThreshold)
    : owner.images;

  return {
    phonesForDisplay,
    emailsForDisplay,
    addressesForDisplay,
    imagesForOverview,
  };
};
